import React from 'react';
import { Handle, Position, NodeProps, useReactFlow } from '@xyflow/react';
import classNames from 'classnames';
import styles from './WorkflowNode.module.css';
import { usePlaceholderClick } from '../hooks/usePlaceholderClick';
import i18n from '../../../i18n';

const PlaceholderNode = ({ id, data }: NodeProps) => {
  const onClick = usePlaceholderClick(id);
  const reactFlowInstance = useReactFlow();
  
  return (
    <div onClick={onClick} className={classNames(styles.node, styles.placeholder)} title={i18n.t('workflow:placeholder.addNode')}>
      {typeof data.label === 'string' ? data.label : String(data.label)}
      <Handle className={styles.handle} type="target" position={Position.Left} isConnectable={false} />
      <Handle className={styles.handle} type="source" position={Position.Right} isConnectable={false} />
    </div>
  );
};

export default PlaceholderNode; 